import React from 'react';
import { Sparkles, Trophy } from 'lucide-react';

export const UnlockModal = ({ onComplete }) => {
  return (
    <div className="fixed inset-0 bg-black/90 z-[10001] flex items-center justify-center" role="dialog">
      <div className="bg-stone-900 border-4 border-amber-500 rounded-xl p-8 max-w-lg shadow-2xl animate-scale-in">
        <div className="text-center">
          <div className="relative mx-auto w-20 h-20 mb-4">
            <Trophy className="w-20 h-20 text-amber-400 animate-bounce" />
            <Sparkles className="w-8 h-8 text-yellow-300 absolute -top-2 -right-2 animate-pulse" />
          </div>

          <h2 className="text-3xl font-bold text-amber-400 mb-2">
            🎉 Tutorial Complete!
          </h2>

          <h3 className="text-xl font-semibold text-stone-100 mb-4">
            Case Generation Unlocked!
          </h3>

          <p className="text-stone-300 mb-6">
            You've mastered the basics of investigation! You can now generate unlimited mystery cases from the main menu. Each case is uniquely crafted with different suspects, motives, and clues.
          </p>

          <button
            onClick={onComplete}
            className="w-full bg-amber-600 hover:bg-amber-700 text-white font-bold py-4 px-6 rounded-lg transition-colors text-lg"
          >
            Start Generating Cases! →
          </button>
        </div>
      </div>
    </div>
  );
};
